import * as THREE from "three";
import { Data } from '../Data';
import { MeshAttributes } from '../ObjectLoader';
import { MaterialFlags } from './MaterialFlags';

export enum MaterialAttributes {
	Sizing = 0x01,
	Correction = 0x02
}
/**
 * Set of materials with shaders for simple, scaled and corrected model
 */
export class MaterialSet{
	public basic: THREE.ShaderMaterial;
	public sized: THREE.ShaderMaterial = null;
	public corrected: THREE.ShaderMaterial = null;
	public angleSensitive: boolean = false;

	constructor(
			shaders: Data.Shaders,
			textures: {[tid: string]: string},
			uniforms: {[uid: string]: Data.Uniform},
			uniformSet: Data.UniformSet,
			materialID: string
		){

		// add additional uniforms
		let uniformsGlob = {};
		for (let uName in uniforms) if (uniforms.hasOwnProperty(uName)){
			let uData = uniforms[uName];
			if (uData.type === 'c') {	// color uniform
				switch (typeof uData.value) {
						// string hex or numeric hex
					case 'string':
					case 'number':
						uData.value = new THREE.Color(uData.value);
						uData.value = uData.value.toArray();
				}
			}
			uniformsGlob[uName] = uData;
		}

		// Use comment "//THREE:<flag>[;<flag>]" on beginning of framgent shader file
		let fragThree = shaders.fragment.match(/^\/\/THREE:(.*)$/m);

		let materialFlags:MaterialFlags = new MaterialFlags(fragThree
				? fragThree[1].split(';')
				: []);

		for (let tID in textures) if (textures.hasOwnProperty(tID)){
			uniformsGlob['tex' + tID] = {type: 't', value: textures[tID]};
			// if (uvTextures.hasOwnProperty(tID))
			// 	tUVs[tID] = uvTextures[tID];
			// tList.push(tID);
			if (tID === 'Alpha')
				materialFlags.useAlpha = true;
		}
		this.angleSensitive = uniformsGlob.hasOwnProperty('fViewAngle');

		this.sized =
		this.corrected =
		this.basic = new THREE.ShaderMaterial({
			uniforms: uniformsGlob,
			vertexShader: shaders.vertex,
			fragmentShader: shaders.fragment
		});
		this.basic.name = materialID;
		materialFlags.setupMaterial(this.basic);

		// uniforms are used in shader-src/general.vert
		// do not clone basic material as uniforms are not initialized properly
		if (shaders.vertexSized){
			uniformsGlob['vSizing'] = uniformSet.size;
			this.sized = new THREE.ShaderMaterial({
				uniforms: uniformsGlob,
				vertexShader: shaders.vertexSized,
				fragmentShader: shaders.fragment
			});
			this.sized.name = materialID+'#sized';
			materialFlags.setupMaterial(this.sized, MaterialAttributes.Sizing);
		}

		if (shaders.vertexCorrected){
			uniformsGlob['vUVScale'] = uniformSet.uvScale;
			this.corrected = new THREE.ShaderMaterial({
				uniforms: uniformsGlob,
				vertexShader: shaders.vertexCorrected,
				fragmentShader: shaders.fragment
			});
			this.corrected.name = materialID+'#corrected';
			materialFlags.setupMaterial(this.corrected, MaterialAttributes.Sizing | MaterialAttributes.Correction);
		}
	}

	/**
	 * Applies proper material to mesh corresponding to available BufferAttributes
	 * @param {Mesh} mesh
	 */
	applyMaterial(mesh:THREE.Mesh){
		let matMesh:THREE.ShaderMaterial = this.basic;
		if ((mesh.geometry instanceof THREE.BufferGeometry) && mesh.geometry.attributes.hasOwnProperty(MeshAttributes.Offset))
			matMesh = mesh.geometry.attributes.hasOwnProperty(MeshAttributes.CorrectionU)
				? this.corrected
				: this.sized;

		// Meshes with name ending "^" have normal issue and their "side" must be altered
		// to render correct side and preserve correct normals at same time
		if (matMesh.transparent && mesh.name.match(/\^$/))
			matMesh.side = THREE.BackSide;
		mesh.material = matMesh;
	}

	/**
	 * Callback for each of available material variants
	 * @param callback Callback to call
	 */
	each(callback:(material:THREE.ShaderMaterial) => void){
		callback(this.basic);
		if (this.sized != this.basic)
			callback(this.sized);
		if (this.corrected != this.sized)
			callback(this.corrected);
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/data/MaterialSet.ts